// extracted by mini-css-extract-plugin
module.exports = {"button":"AppButton_button__2N8-w","lds-dual-ring":"AppButton_lds-dual-ring__1eGb9","lds-dual-ring-primary":"AppButton_lds-dual-ring-primary__xtz_j"};